import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { Box, Button } from '@mui/material/';
import { Link, useNavigate } from 'react-router-dom'
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

export default function RegistrationInputs() {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    const navigate = useNavigate();

    const handleEmailChange = (event) => {
        const inputValue = event.target.value
        setEmail(inputValue.toString());
    };

    const handlePassChange = (event) => {
        const inputValue = event.target.value
        setPass(inputValue.toString());
    };

    const handleFormSubmit = async () => {

        signInWithEmailAndPassword(auth, email, pass)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            console.log(`${user.toJSON().displayName} signed in`);
            navigate('/');
        })
        .catch((error) => {
            console.log(error);
        });

    };

    return (
        <Box m={2}>
            <Box mb={2}>
                <TextField
                    label="Email"
                    type="text"
                    placeholder="Enter Email"
                    value={email}
                    onChange={handleEmailChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
            <Box mb={2}>
                <TextField
                    label="Password"
                    type="password"
                    placeholder="Enter Password"
                    value={pass}
                    onChange={handlePassChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
            <Button variant="contained" onClick={handleFormSubmit}>
                Login
            </Button>
            <Box>
                <Link to={`/register`} activeClassName="active">Don't have an account?</Link>
            </Box>
        </Box>
    );
}